// Tiny reactive store backed by localStorage. Tracks entry ids the user has
// opened. Svelte 5 runes so the set is reactive across components.

const KEY = 'grimoire:visited:v1';

function load(): Set<string> {
  if (typeof localStorage === 'undefined') return new Set();
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? new Set(arr.filter((x) => typeof x === 'string')) : new Set();
  } catch {
    return new Set();
  }
}

let set = $state<Set<string>>(load());

function persist() {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(KEY, JSON.stringify([...set]));
  } catch {
    // ignore quota / private-mode errors
  }
}

export const visited = {
  get size() {
    return set.size;
  },
  has(id: string) {
    return set.has(id);
  },
  mark(id: string) {
    if (set.has(id)) return;
    // Svelte 5: assign a new Set so the reactive ref bumps.
    const next = new Set(set);
    next.add(id);
    set = next;
    persist();
  },
  clear() {
    set = new Set();
    persist();
  },
};
